import { ForwardedRef, forwardRef } from "react";
import { FieldError } from "react-hook-form";

interface TTextInputBaseProps extends React.ComponentPropsWithRef<"input"> {
  label?: string;
  icon?: React.ReactNode;
  error?: FieldError;
  containerClass?: string;
}

const TextInputBaseUnstyled = forwardRef<HTMLInputElement, TTextInputBaseProps>(
  (
    { label, icon, error, containerClass, ...rest },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    TextInputBaseUnstyled.displayName = "TextInputBaseUnstyled";
    const isError = error?.message ? true : false;
    return (
      <div className={`flex flex-col w-full ${containerClass}`}>
        {label && (
          <label className="text-xs text-left text-body font-semibold pl-1">
            {label}
          </label>
        )}
        <section className="w-full relative">
          <input
            {...rest}
            ref={ref}
            autoComplete="off"
            className={`h-10 w-full text-sm text-body font-semibold px-3 py-1 
            placeholder:font-medium placeholder:text-darkGray outline-none  z-10
            disabled:bg-gray-200 disabled:cursor-not-allowed ${rest.className}`}
          />

          <span
            className={`${
              isError ? "text-error" : "text-darkGray/80"
            } absolute w-5 right-3 top-1/2 -translate-y-1/2 `}
          >
            {icon}
          </span>
        </section>
        {isError && (
          <p className="text-xs text-error/90 font-medium pl-1 ">
            {error?.message}
          </p>
        )}
      </div>
    );
  }
);

export default TextInputBaseUnstyled;
